import {
  Instance,
  Modal,
  NotificationLevel,
  ProfileFields,
  ProfilePasswordFields,
  ProfileWebHookFields,
  WebhookAuthType, WebhookEvents
} from '@const/consts';
import { IProfileAccountFieldsSettings, IProfileModalButtonsSettings } from '@views/profile/types';

export enum FieldType {
  INPUT = 'INPUT',
  PHONE = 'PHONE',
  SELECT = 'SELECT',
  CHECKBOX = 'CHECKBOX',
  RADIO_BUTTON = 'RADIO_BUTTON',
  TOGGLE = 'TOGGLE',
}

export const ProfileAccountInputsSettings: IProfileAccountFieldsSettings[] = [
  {
    fieldName: ProfileFields.LAST_NAME,
    label: 'profile:fieldLabel:lastName',
    required: true
  },
  {
    fieldName: ProfileFields.FIRST_NAME,
    label: 'profile:fieldLabel:firstName',
    required: true
  },
  {
    fieldName: ProfileFields.MIDDLE_NAME,
    label: 'profile:fieldLabel:middleName',
  },
  {
    fieldName: ProfileFields.FULL_NAME,
    label: 'profile:fieldLabel:fullName',
    wrapperClasses: 'grid-item-4',
    disabled: true,
    required: true
  },
  {
    fieldName: ProfileFields.INITIALS,
    label: 'profile:fieldLabel:initials',
  },
  {
    fieldName: ProfileFields.EMAIL,
    label: 'profile:fieldLabel:email',
    disabled: true
  },
  {
    fieldType: FieldType.PHONE,
    fieldName: ProfileFields.PHONE,
    label: 'profile:fieldLabel:phone',
    disabled: true,
  },
]

export const ProfileAccountSelectsSettings: IProfileAccountFieldsSettings[] = [
  {
    fieldType: FieldType.SELECT,
    fieldName: ProfileFields.LOCALE,
    label: 'profile:fieldLabel:locale',
    required: true,
    optionsMetadata: 'locales',
    wrapperClasses: 'grid-item-2 relative'
  },
  {
    fieldType: FieldType.SELECT,
    fieldName: ProfileFields.TIME_ZONE,
    label: 'profile:fieldLabel:timeZone',
    required: true,
    optionsMetadata: 'timeZones',
    wrapperClasses: 'grid-item-2 relative'
  }
]

export const ProfileOrganizationInputsSettings: IProfileAccountFieldsSettings[] = [
  {
    fieldName: ProfileFields.COMPANY_NAME,
    label: 'profile:fieldLabel:nameCompany',
    wrapperClasses: 'grid-item-8',
  },
  {
    fieldName: ProfileFields.COMPANY_ZIP,
    label: 'profile:fieldLabel:postcode',
    wrapperClasses: 'grid-item-2',
  },
  {
    fieldName: ProfileFields.COMPANY_ADDRES,
    label: 'profile:fieldLabel:organizationAddress',
    wrapperClasses: 'grid-item-6',
  },
  {
    fieldName: ProfileFields.POSITION,
    label: 'profile:fieldLabel:position',
    wrapperClasses: 'grid-item-8',
  }
]

export const ProfileNotificationCheckboxesSettings: IProfileAccountFieldsSettings[] = [
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: ProfileFields.IS_EMAIL_NOTIFICATION,
    label: 'profile:fieldLabel.notification.email',
    labelClasses: 'd-flex text-color',
    wrapperClasses: 'pr-4',
    itemClasses: 'mr-2'
  },
  // {
  //   fieldType: FieldType.CHECKBOX,
  //   fieldName: ProfileFields.IS_DEVICE_NOTIFICATION,
  //   label: 'profile:fieldLabel.notification.app',
  //   labelClasses: 'd-flex text-color',
  //   wrapperClasses: 'pr-4',
  //   itemClasses: 'mr-2'
  // },
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: ProfileFields.IS_PHONE_NOTIFICATION,
    label: 'profile:fieldLabel.notification.sms',
    labelClasses: 'd-flex text-color',
    wrapperClasses: '',
    itemClasses: 'mr-2'
  }
]

export const ProfileNotificationRadioButtonsSettings: IProfileAccountFieldsSettings[] = [
  {
    fieldType: FieldType.RADIO_BUTTON,
    fieldName: ProfileFields.NOTIFICATION_LEVEL,
    label: 'profile:fieldLabel:notification:onlyIncoming',
    checkedValue: NotificationLevel.ONLY_INCOMING,
    labelClasses: 'd-flex text-color',
    itemClasses: 'mr-1',
    wrapperClasses: 'mb-3',
  },
  {
    fieldType: FieldType.RADIO_BUTTON,
    fieldName: ProfileFields.NOTIFICATION_LEVEL,
    label: 'profile:fieldLabel:notification:incomingAndFinished',
    checkedValue: NotificationLevel.INCOMING_AND_FINISHED,
    labelClasses: 'd-flex text-color',
    itemClasses: 'mr-1'
  }
]

export const ProfileAccountModalButtonsSettings: IProfileModalButtonsSettings[] =
  [
    {
      modalID: Modal.CHANGE_PASSWORD,
      title: 'profile:changePassword',
      classes: 'mr-4',
    },
    {
      modalID: Modal.API_ACCESS_TOKEN,
      title: 'profile:integrationOptions',
      classes: 'mr-4',
    },
    {
      modalID: Modal.WEB_HOOKS,
      title: 'profile:settingWebHooks',
      classes: 'mr-4',
    },
    {
      modalID: Modal.BUSINESS_BOX,
      title: 'boxes:create',
      classes: 'mr-4',
    },
    {
      modalID: Modal.CERTIFICATE_POWER,
      title: 'profile:settingPoA',
      classes: 'mr-4',
      instance: Instance.RU,
    },
  ];

export const ProfileSignatureModalButtonsSettings: IProfileModalButtonsSettings[] = [
  {
    modalID: Modal.SIGNATURE_IMAGE_DRAW,
    title: 'profile:signature:draw',
    classes: 'mr-4'
  },
  {
    modalID: Modal.SIGNATURE_IMAGE_UPLOAD,
    title: 'profile:signature:upload'
  }
]

export const ProfilePasswordSettings: IProfileAccountFieldsSettings[] = [
  {
    fieldName: ProfilePasswordFields.NEW_PASSWORD,
    label: 'profile:fieldLabel:newPassword',
    itemClasses: 'mt-1',
    type: 'password',
    wrapperClasses: 'mb-4'
  },
  {
    fieldName: ProfilePasswordFields.CONFIRM_PASSWORD,
    label: 'profile:fieldLabel:confirmPassword',
    itemClasses: 'mt-1',
    type: 'password',
    wrapperClasses: 'mb-4'
  }
]

export const ProfileWebHooksSettings: IProfileAccountFieldsSettings[] = [
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: ProfileWebHookFields.IS_WEBHOOK_ENABLE,
    label: 'profile:webHook:enabled',
    labelClasses: 'd-flex font-default text-color',
    itemClasses: 'mr-2',
    wrapperClasses: 'mb-4'
  },
  {
    fieldName: ProfileWebHookFields.WEBHOOK_URL,
    label: 'profile:webHook:link',
    wrapperClasses: 'mb-4',
    itemClasses: 'mt-1'
  },
  {
    fieldType: FieldType.SELECT,
    fieldName: ProfileWebHookFields.WEBHOOK_AUTH_TYPE,
    label: 'profile:webHook:authType',
    wrapperClasses: 'mb-4',
    itemClasses: 'mt-1',
    options: [
      {
        value: WebhookAuthType.NOAUTH,
        label: WebhookAuthType.NOAUTH
      },
      {
        value: WebhookAuthType.BASIC,
        label: WebhookAuthType.BASIC
      },
      {
        value: WebhookAuthType.BEARER,
        label: WebhookAuthType.BEARER
      },
      {
        value: WebhookAuthType.X_API_KEY,
        label: WebhookAuthType.X_API_KEY
      }
    ]
  },
  {
    fieldName: ProfileWebHookFields.WEBHOOK_AUTH_TOKEN,
    label: 'profile:webHook:authToken',
    wrapperClasses: 'mb-4',
    itemClasses: 'mt-1'
  }
]

export const ProfileWebHooksEventsSettings: IProfileAccountFieldsSettings[] = [
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: WebhookEvents.SENT,
    label: 'profile:webHook:sending',
    labelClasses: 'd-flex font-default text-color',
    itemClasses: 'mr-2'
  },
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: WebhookEvents.STOPPED_PROCESS,
    label: 'profile:webHook:stop',
    labelClasses: 'd-flex font-default text-color',
    itemClasses: 'mr-2'
  },
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: WebhookEvents.SIGNED,
    label: 'profile:webHook:signing',
    labelClasses: 'd-flex font-default text-color',
    itemClasses: 'mr-2'
  },
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: WebhookEvents.ACQUAINTED,
    label: 'profile:webHook:acquaintance',
    labelClasses: 'd-flex font-default text-color',
    itemClasses: 'mr-2'
  },
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: WebhookEvents.RECEIVED,
    label: 'profile:webHook:receipt',
    labelClasses: 'd-flex font-default text-color',
    itemClasses: 'mr-2'
  },
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: WebhookEvents.DECLINED,
    label: 'profile:webHook:refusal',
    labelClasses: 'd-flex font-default text-color',
    itemClasses: 'mr-2'
  },
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: WebhookEvents.APPROVED,
    label: 'profile:webHook:agreement',
    labelClasses: 'd-flex font-default text-color',
    itemClasses: 'mr-2'
  }
]

/** Параметры КЭП */
export const ProfileElectronicSignatureSettings = [
  {
    fieldType: FieldType.CHECKBOX,
    fieldName: ProfileFields.USE_TIME_SERVICE,
    label: 'profile:signature.enhanced',
    labelClasses: 'd-flex text-color',
    wrapperClasses: 'pr-2',
    itemClasses: 'mr-2'
  },
]
